module.exports = __webpack_public_path__ + "img/green-check.76316fba.png";